import { render, staticRenderFns } from "./NotificationRow.vue?vue&type=template&id=dd050960&scoped=true"
import script from "./NotificationRow.vue?vue&type=script&lang=js"
export * from "./NotificationRow.vue?vue&type=script&lang=js"
import style0 from "./NotificationRow.vue?vue&type=style&index=0&id=dd050960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd050960",
  null
  
)

export default component.exports